import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { filter } from 'lodash';
import { Global } from './global.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PublicationsService {



  constructor(private http: HttpClient, private global: Global) { }

  httpOptions = {
    headers: new HttpHeaders({
      "accept": "application/json;odata=Nometadata",
      "content-type": "application/json;odata=verbose"
    })
  };
  getPress(url) {
    return this.http.get(url + "/_api/web/lists/GetByTitle('CommuniquesPress')/items?$select=FileRef,*&$filter=Publier eq 1"
      + "&$orderby=PressDate desc&$top=10", this.httpOptions);
  }
  getAllPress(url) {
    return this.http.get(url + "/_api/web/lists/GetByTitle('CommuniquesPress')/items?$select=FileRef,*&$filter=Publier eq 1"
      + "&$orderby=PressDate desc&$top=2500", this.httpOptions);
  }
  getActualite(url, isAlaUne = false) {
    let filter = "";
    isAlaUne ? filter = " and ActualiteAlaune eq 1&$top=6" : filter = "&$top=10";
    return this.http.get(url + "/_api/web/lists/GetByTitle('Actualites')/items?$filter=ActualitePublier eq 1" + filter
      + "&$orderby=AcualiteDate desc", this.httpOptions);
  }
  getAllActualites(url) {
      return this.http.get(url + "/_api/web/lists/GetByTitle('Actualites')/items?$filter=ActualitePublier eq 1" 
        + "&$orderby=AcualiteDate desc&$top=2500", this.httpOptions);
  }
  getActualitebyId(url, id) {
    return this.http.get(url + "/_api/web/lists/GetByTitle('Actualites')/items?"
      + "$filter=ID eq " + id, this.httpOptions);
  }
  // getOffres(url, isAlaUne = false) {

  //   let top = "";
  //   isAlaUne ? top = "&$top=6" : top = "&$top=5000";
  //   let d = new Date();
  //   d.setDate(d.getDate() - 365);
  //   let dtime = d.toISOString();
  //   return this.http.get(this.global._basedUrl + this.global._FrUrl + "/_api/web/lists/GetByTitle('AppelOffres')/items?$select=*"
  //     + "&$filter=Publier eq 1 and Date_x0020_limite_x0020_de_x00200 ge datetime'" + dtime + "'"
  //     + "&$orderby=Date_x0020_limite_x0020_de_x00200 desc"
  //     + top, this.httpOptions);
  // }

  getOffres(url,isAlaUne = false){
    const top = isAlaUne ? 6 : 600;
  
    const dateLimit = new Date();
    dateLimit.setDate(dateLimit.getDate() - 365);
    const isoDate = dateLimit.toISOString();
  
    const listUrl = `${this.global._basedUrl}${this.global._FrUrl}/_api/web/lists/GetByTitle('AppelOffres')/items`;
    
    const query = [
      `$filter=Publier eq 1 and Programme_region eq 0 and Date_x0020_limite_x0020_de_x00200 ge datetime'${isoDate}'`,
      `$orderby=Date_x0020_limite_x0020_de_x00200 desc`,
      `$top=${top}`
    ].join("&");
  
    return this.http.get(`${listUrl}?${query}`, this.httpOptions);
  }
  
  getProgrammePrev(url, isAlaUne = false) {

    let top = "";
    isAlaUne ? top = "&$top=6" : top = "&$top=5000";
    let d = new Date();
    d.setFullYear(d.getFullYear() + 1, 0, 0);
    d.setHours(23, 59, 59, 999);
    console.log("date", d);
    d.setDate(d.getDate() - 400);
    let dtime = d.toISOString();
    return this.http.get(this.global._basedUrl + this.global._FrUrl + "/_api/web/lists/GetByTitle('AppelOffres')/items?$expand=AttachmentFiles&"
      + "&$filter=Publier eq 1 and Programme_region eq 1 and Date_x0020_limite_x0020_de_x00200 ge datetime'" + dtime + "'"
      + "&$orderby=Date_x0020_limite_x0020_de_x00200 desc"
      + top, this.httpOptions);
  }
  getEmplois(url) {
    let d = new Date();
    d.setDate(d.getDate() - 365);
    let dtime = d.toISOString();
    return this.http.get(this.global._basedUrl + this.global._FrUrl + "/_api/web/lists/GetByTitle('OffresEmplois')/items?"
      + "$filter=Publier eq 1 and (EtapeActuelle ne 'Résultats du concours' or (EtapeActuelle eq 'Résultats du concours' and Date_Mise_Jour ge '" + dtime + "'))"
      + "&$top=5000&$orderby=Date_Mise_Jour desc", this.httpOptions);
  }
  getRegions() {
    return this.http.get(this.global._basedUrl + "/_api/web/lists/GetByTitle('Region')/items", this.httpOptions);
  }
  getOffreId(url, id) {
    return this.http.get(this.global._basedUrl + this.global._FrUrl + "/_api/web/lists/GetByTitle('AppelOffres')/items?$expand=AttachmentFiles&"
      + "$filter=Publier eq 1 and ID eq " + id, this.httpOptions);
  }
  getEmploiById(url, id) {
    return this.http.get(this.global._basedUrl + this.global._FrUrl + "/_api/web/lists/GetByTitle('OffresEmplois')/items?$select=*,AttachmentFiles&$expand=AttachmentFiles&"
      + "$filter=Publier eq 1 and ID eq " + id, this.httpOptions);
  }

  getAConcurrences(url: any) {
    return this.http.get(this.global._basedUrl + this.global._FrUrl + "/_api/web/lists/GetByTitle('Appel%20Concurrence')/items?$select=*,AttachmentFiles&$expand=AttachmentFiles&"
      + "$filter=publier eq 1&$orderby=Date_x0020_Ouverture desc ", this.httpOptions);
  }
  getAConcurrenceId(url, id) {
    return this.http.get(this.global._basedUrl + this.global._FrUrl + "/_api/web/lists/GetByTitle('Appel%20Concurrence')/items?$select=*,AttachmentFiles&$expand=AttachmentFiles&"
      + "$filter=publier eq 1 and ID eq " + id, this.httpOptions);
  }

    // Method to post data to Historique AC
    // AddAppelConcurranceClient(data: any)
    // {
    //   return this.http.post(this.global._basedUrl + this.global._FrUrl + "/_api/web/lists/getbytitle('Historique%20Appel%20candidatures')/items", JSON.stringify(data), this.httpOptions);
    // }
    // Method to get X-RequestDigest

  getRequestDigest() {
    return this.http.post(this.global._basedUrl + this.global._FrUrl + '/_api/contextinfo', null, this.httpOptions);
  }

  
  // Add Appel Concurrance Client with X-RequestDigest token
  AddAppelConcurranceClient(data: any, requestDigest: string) {
    const headers = new HttpHeaders({
      'Accept': 'application/json;odata=verbose',
      'Content-Type': 'application/json;odata=verbose',
      'X-RequestDigest': requestDigest
    });

    return this.http.post(
      this.global._basedUrl + this.global._FrUrl + "/_api/web/lists/getbytitle('Historique%20Appel%20candidatures')/items",
      JSON.stringify(data),
      { headers }
    );
  }

    DownloadACDossier() {
      return this.http.get(this.global._basedUrl + this.global._FrUrl + "/_api/web/GetFolderByServerRelativeUrl('Dossiers%20Appel%20%20Concurrence')/Files?$expand=ListItemAllFields", this.httpOptions);
    }

    AddAmi(data: any, requestDigest: string) {
      const headers = new HttpHeaders({
        'Accept': 'application/json;odata=verbose',
        'Content-Type': 'application/json;odata=verbose',
        'X-RequestDigest': requestDigest
      });
  
      return this.http.post(
        this.global._basedUrl + this.global._FrUrl + "/_api/web/lists/getbytitle('AMI')/items",
        JSON.stringify(data),
        { headers }
      );
    }

    getSociteAutorisee() {
      return this.http.get(this.global._basedUrl + "/_vti_bin/WS/Service.svc/getSociete" , this.httpOptions);
    }
    
  
}